export const PAGE_CONTENT_HEADER_MAX_WIDTH = 650;
